import { Timeframe } from '@adornis/bh-timeframes/entities/Timeframe.js';
import { WorkshopSet } from '@adornis/buchungsheld-db/entities/WorkshopSet.js';
import { webcomponent } from '@adornis/functional-lit/webcomponent.js';
import { makeRouter } from '@adornis/router/client/make-router.js';
import { html } from 'lit';
import { provideContextEntity } from '../../../../util.js';
import { workshopSetModify } from './bh-page-admin-einrichtung-workshop-set-modify.js';
import { workshopSetOverview } from './bh-page-admin-einrichtung-workshop-set-overview.js';

webcomponent('bh-admin-page-wrapper', () => {
  // TODO: add breadcrumbs here
  return html`<slot></slot>`;
});

export const adminEinrichtungWorkshopSetRouter = makeRouter(
  {
    root: {
      path: '/',
      metaData: {
        breadcrumbs: ({ params }) => [{ content: 'Workshop Reihen', active: true }],
        semesterSelect: true,
      },
      render: () => workshopSetOverview.render(),
    },
    add: {
      path: '/add',
      metaData: {
        breadcrumbs: ({ params }) => [
          { content: 'Workshop Reihen', href: `/admin/institution-details/${params.institutionID}/sets-workshop` },
          { content: 'Workshop-Reihe anlegen', active: true },
        ],
      },
      render: params => {
        const institutionID = params.institutionID;
        const $instance = new WorkshopSet({ institutionID });
        const provider = provideContextEntity(WorkshopSet, { $instance });
        const content = workshopSetModify.render();
        return html`<bh-admin-page-wrapper ${provider}>${content}</bh-admin-page-wrapper>`;
      },
    },
    modify: {
      path: '/modify/:workshopSetID',
      metaData: {
        breadcrumbs: ({ params }) => [
          { content: 'Workshop Reihen', href: `/admin/institution-details/${params.institutionID}/sets-workshop` },
          { content: 'Workshop-Reihe bearbeiten', active: true },
        ],
      },
      render: params => {
        const workshopSetID = params.workshopSetID;
        const timeframeID = params.timeframeID;
        const workshopsetProvider = provideContextEntity(WorkshopSet, { $id: workshopSetID });
        const timeframeProvider = provideContextEntity(Timeframe, { $id: timeframeID });
        const content = workshopSetModify.render();
        return html`<bh-admin-page-wrapper ${workshopsetProvider} ${timeframeProvider}
          >${content}</bh-admin-page-wrapper
        >`;
      },
    },
  },
  {
    fallback: () => html` <x-empty-placeholder .img=${'close'} .text=${'404'} no-wrapper></x-empty-placeholder> `,
  },
);
